import React from 'react';
import { Route, Switch } from 'react-router';
import { contratosMenuRoutes } from '../constants';

export const ContratosMenuRoutes = () => {

  return (
		<Switch>
			{
				contratosMenuRoutes.map((route, index) => {
					return (
						<Route
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />						
					)
				})
			}
		</Switch>
	);
}